import { DEFAULT_CONFIGS } from "./constants";
import { GIPHY_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginGiphy = (config) => {
  return {
    config: { ...DEFAULT_CONFIGS.viewer, ...config },
    type: GIPHY_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginGiphy
};
//# sourceMappingURL=viewer-loadable.js.map
